const responseLogin = {
  "payload": {
    "userid": 1,
    "idGroup": "1",
    "message": "Login exitoso",
    "termsConditionsAccepted": false,
    "isPasswordChangeRequiredOnFirstLogin": false,
    "listAllowedScreens": [
      {
        "screen": "purchase_reconciliation"
      },
      {
        "screen": "home"
      },
      {
        "screen": "buy_recognition"
      },
      {
        "screen": "product"
      },
      {
        "screen": "suppliers"
      },
      {
        "screen": "marketplace"
      },
      {
        "screen": "board"
      },
      {
        "screen": "companies"
      },
      {
        "screen": "users_admin"
      },
      {
        "screen": "users_admin"
      },
      {
        "screen": "buy_recognition"
      },
      {
        "screen": "shape_assignment"
      },
      {
        "screen": "reports"
      },
      {
        "screen": "bonus"
      },
      {
        "screen": "ads"
      },
      {
        "screen": "zen_star"
      },
      {
        "screen": "mindset"
      },
      {
        "screen": "tips-categories"
      },
      {
        "screen": "happiness-tips"
      }
    ],
    "pusher_SECRET": "a49f8c0d4eba91d635de",
    "pusher_KEY": "06d012aa87d8cd1dcd7b"
  }
};

const responseTyC = {
  "payload": {
    "listTermsUrl": [
      {
        "termsAndConditionsId": 1,
        "description": "Términos y Condiciones", 
        "urlTermsAndConditions": "http"
      },
      {
        "termsAndConditionsId": 2,
        "description": "Política de Privacidad", 
        "urlTermsAndConditions": "http"
      },
      {
        "termsAndConditionsId": 3,
        "description": "Política de Cookies", 
        "urlTermsAndConditions": "http"
      }
    ],
    "message": "texto"
  }
};

export const service = {
  postLogin: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseLogin }), 1000);
  }),
  getTermsConditions: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseTyC }), 1000);
  }),
  postTermsConditions: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseTyC }), 1000);
  }),
}